import React from 'react';
import { Modal, Form, Input, Divider, Switch, InputNumber } from 'antd';

interface DeviceSettings {
  id: string;
  profile_name: string;
  photo_enabled: boolean;
  audio_enabled: boolean;
  gps_enabled: boolean;
  photo_interval: number;
  gps_interval: number;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

interface DeviceProfileManagerProps {
  showCreateProfile: boolean;
  createProfileForm: any;
  settingsProfiles: DeviceSettings[];
  onCreateProfile: () => void;
  onCancel: () => void;
}

const DeviceProfileManager: React.FC<DeviceProfileManagerProps> = ({
  showCreateProfile,
  createProfileForm,
  settingsProfiles,
  onCreateProfile,
  onCancel,
}) => {
  return (
    <Modal
      title="新しいプロファイルを作成"
      open={showCreateProfile}
      onOk={onCreateProfile}
      onCancel={onCancel}
      okText="作成"
      cancelText="キャンセル"
    >
      <Form form={createProfileForm} layout="vertical">
        <Form.Item
          name="profile_name"
          label="プロファイル名"
          rules={[
            { required: true, message: 'プロファイル名を入力してください' },
            { max: 50, message: '50文字以内で入力してください' },
            { 
              validator: (_, value) => {
                if (value === 'default') {
                  return Promise.reject('「default」は使用できません');
                }
                if (settingsProfiles.some(p => p.profile_name === value)) {
                  return Promise.reject('このプロファイル名は既に存在します');
                }
                return Promise.resolve();
              }
            }
          ]}
        >
          <Input placeholder="例: 会議用、外出用" />
        </Form.Item>
        
        <Divider>初期設定</Divider>
        
        <Form.Item name="photo_enabled" valuePropName="checked" initialValue={true}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>写真データ送信</span>
            <Switch />
          </div>
        </Form.Item>
        
        <Form.Item name="audio_enabled" valuePropName="checked" initialValue={true}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>音声データ送信</span>
            <Switch />
          </div>
        </Form.Item>
        
        <Form.Item name="gps_enabled" valuePropName="checked" initialValue={true}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>GPSデータ送信</span>
            <Switch />
          </div>
        </Form.Item>
        
        <Form.Item name="photo_interval" label="写真撮影間隔（秒）" initialValue={60}>
          <InputNumber min={1} max={300} style={{ width: '100%' }} />
        </Form.Item>
        
        <Form.Item name="gps_interval" label="GPS送信間隔（秒）" initialValue={10}>
          <InputNumber min={1} max={60} style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DeviceProfileManager;